__turbopack_context__.v({
  "blink": "ProjectFeatured-module-scss-module__liIC2G__blink",
  "content": "ProjectFeatured-module-scss-module__liIC2G__content",
  "hidden": "ProjectFeatured-module-scss-module__liIC2G__hidden",
  "image": "ProjectFeatured-module-scss-module__liIC2G__image",
  "imageContainer": "ProjectFeatured-module-scss-module__liIC2G__imageContainer",
  "imageFull": "ProjectFeatured-module-scss-module__liIC2G__imageFull",
  "imageHover": "ProjectFeatured-module-scss-module__liIC2G__imageHover",
  "projectFeatured": "ProjectFeatured-module-scss-module__liIC2G__projectFeatured",
});
